import React from 'react'
import Layout from '../../components/user/Layout'
import DownloadApply from '../../components/web/form/DownloadApply'

function Applyform() {
  return (
    <Layout>
      <DownloadApply/>
    </Layout>
  )
}

export default Applyform
